// ATTN we use these constants in data dump
const abTests = {
  // CRO tests
  paymentQueueEditPopup: 'payment:queueEditPopup', // CRO-338
  tyHideAddedProduct: 'ty:hideAddedProduct', // CRO-270
  quizDesignUpdate: 'quiz:designUpdate', // CRO-380
  subscriptionAndShippingInfo: 'home:subscriptionAndShippingInfoV2', // CRO-359
  scentProfileQueueWidget: 'scentProfile:queueWidget', // CRO-430
  tySkipQueueStep: 'ty:skipQueueStep', // CRO-384
  paymentSeparateShipping: 'payment:separateShipping', // CRO-411
  // EP tests
  queueStickyBanner: 'queue:stickyBanner', // EP-2100
  queueCaseSubscriptionBanner: 'queue:CaseSubscriptionBanner', // EP-2123
  cancelButton: 'cancelButton25', // EP-2144
  csBadge: 'cs:badge', // EP-2219
  burgerMenu: 'burgerMenu', // EP-2241
  homeCanada50vs60: 'home:canada50vs60', // EP-2181
  upgradeEntryPoints: 'upgradeEntryPoints', // EP-2237
  burgerMenuBannersForLeads: 'burgerMenuBannersForLeads', // EP-2242
  burgerMenuBannersForActive: 'burgerMenuBannersForActive', // EP-2242
  upgradePopup: 'upgradePopup', // EP-2262
  navScentHoroscopeInPerfumes: 'nav:scentHoroscopeInPerfumes', // EP-2364
  caseUpsellOptions12vs3: 'caseUpsellOptions12vs3', // EP-2419
  applePayInCart: 'cart:applePay', // EP-2763
  // PF tests
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  limitedDropsCheckoutRedirect: 'limitedDropsCheckoutRedirect', // PF-2107
  recommendedForYouNavLink: 'nav:recommendedForYouNavLink', // PF-2295
  theValentinesEdit: 'theValentinesEdit', // PF-2316
  theLuxeEdit: 'theLuxeEditV2', // PF-2354
  queueDragTooltip: 'queueDragTooltip', // PF-2299
  constructorRecommendations: 'constructorRecommendations', // PF-2319
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
